"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_LOCATION = "@angular-redux/router::UPDATE_LOCATION";
//# sourceMappingURL=actions.js.map